import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconPipeModule } from '../icon-pipe/icon-pipe.module';
import { SelectSearchModule } from '../select-search/select-search.module';
import { AppButtonModule } from './../app-button-module/app-button.module';
import { AppFilterComponent } from './app-filter/app-filter.component';
import { FilterCardComponent } from './filter-card/filter-card.component';
import { CustomFormsModule } from '../../custom-forms-module/custom-forms.module';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import {MatLegacyPaginatorModule} from '@angular/material/legacy-paginator';
import {
    SelectSearchPagedOptionsComponent
} from '../select-search/components/select-search-paged-options/select-search-paged-options.component';


@NgModule({
    declarations: [AppFilterComponent, FilterCardComponent],
    exports: [AppFilterComponent, FilterCardComponent],
    imports: [
        CommonModule,
        MatSlideToggleModule,
        FormsModule,
        FontAwesomeModule,
        IconPipeModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        AppButtonModule,
        ReactiveFormsModule,
        SelectSearchModule,
        MatCardModule,
        CustomFormsModule,
        MatTooltipModule,
        MatLegacyPaginatorModule,
        SelectSearchPagedOptionsComponent,
    ],
})
export class AppFilterModule {
    constructor() {}
}
